
import { Component, Vue } from 'vue-property-decorator'

/**
 * ファイル選択欄の基底コンポーネント
 */
@Component
export default class InputFileBase extends Vue {
  /**
   * 入力時のイベント
   *
   * @param event イベント
   */
  private changeEvent(event: Event): void {
    this.$emit('change', (event.target as HTMLInputElement).files)
  }
}
